export default __webpack_public_path__ + "static/media/composicao-com-gravuras.1e135176.mp3";